import * as React from 'react';
import { Link } from 'react-router-dom';

import { addModifiers, formatDuration } from '../../shared/helpers';

import './VideoPlayList.scss';

export const VideoPlayList = ({ title, items, current, path, onItemClick }: any) => (
  <div className="video-play-list">
    <div className="video-play-list__header">{title}</div>
    <div className="video-play-list__container">
      <ul className="video-play-list__list">
        {items.videos.map((item: any, index: number) => {
          const duration = formatDuration(item.duration);
          return (
            <Link
              className={addModifiers('video-play-list__item', index === current ? ['active'] : [])}
              key={`video-play-list-${item.id}`}
              to={`/${path}/courses/${items.id}/${items.videos[index].id}`}
              onClick={onItemClick ? () => onItemClick(items.videos[index].id) : undefined}
            >
              <div className="video-play-list__item-title">
                <div className="video-play-list__item-link">{`${index + 1}.  ${item.title}`}</div>
              </div>
              <div className="video-play-list__item-actions">
                {item.check && <span className="video-play-list__check" />}
                {duration && <span className="video-play-list__time">{duration}</span>}
              </div>
            </Link>
          );
        })}
      </ul>
    </div>
  </div>
);
